import { createRoutine } from 'redux-saga-routines';

const FETCH_ALL_PROPERTY_CATEGORIES = 'FETCH_ALL_PROPERTY_CATEGORIES';
const fetchAllPropertyCategoriesAction = createRoutine(FETCH_ALL_PROPERTY_CATEGORIES);

const FETCH_FEATURED_PROPERTY_CATEGORIES = 'FETCH_FEATURED_PROPERTY_CATEGORIES';
const fetchFeaturedPropertyCategoriesAction = createRoutine(FETCH_FEATURED_PROPERTY_CATEGORIES);

export { fetchAllPropertyCategoriesAction, fetchFeaturedPropertyCategoriesAction };
